/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/',
          name: 'page-login',
          component: () => import('@/views/pages/ingreso.vue')
        },
        {
          path:'/bloqueo',
          name:'bloqueo',
          component: () => import('@/views/pages/bloqueo.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        //==RUTAS EXTERNAS LIBROS===
        {
          path: "/docente/libro/digital",
          name: "digitallibro",
          component: () => import("@/views/libros/digital.vue")
        },
        {
          path: "/estudiante/libro/digital",
          name: "digitallibro",
          component: () => import("@/views/estudiantes/digital.vue")
        },
        {
          path: "/admin/libro/desgloselibro",
          name: "admin-libro",
          component: () => import("./views/libros/libro-despliegue.vue"),
        },
        {
          path: "/admin/libro/pdfsinguia",
          name: "admin-libro-singuia",
          component: () => import("./views/libros/admin-pdfsinguia.vue"),
        },
        {
          path: "/docente/libro/pdfconguia",
          name: "digitallibro",
          component: () => import("@/views/libros/pdfconguia.vue"),
        },
        {
          path: "/docente/libro/pdfguiadidactica",
          name: "digitallibro",
          component: () => import("@/views/libros/guiadidactica.vue"),
        },
        {
          path: "/libro_free/:data_link",
          name: "libro_free",
          component: () => import("@/views/libros/libro_free.vue"),
        },
        // {
        //   path: "/games",
        //   name: "admin-games",
        //   component: () => import("./views/games/screen.vue"),
        //   meta: {
        //     breadcrumb: [
        //       { title: "Inicio", url: "/" },
        //       { title: "Games", active: true }
        //     ]
        //   }
        // },
        //==FIN RUTAS EXTERNAS LIBROS=====
      ]
    },

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/home',
          name: 'home',
          component: () =>
            import('@/views/Home.vue')
        },
        {
          path: "/games",
          name: "admin-games",
          component: () => import("./views/games/screen.vue"),
          meta: {
            breadcrumb: [
              { title: "Inicio", url: "/" },
              { title: "Games", active: true }
            ]
          }
        },
        {
          path: '/perfil',
          name: 'perfil',
          component: () =>
            import('@/views/usuarios/screen.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/home' },
                { title: 'Perfil', active: true },
              ],            
          }
        },
        {
          path: '/areas',
          name: 'Areas',
          component: () =>
            import('@/views/area/areas.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/home' },
                { title: 'Áreas', active: true },
              ],            
          }
        },
        {
          path: '/areas/nueva',
          name: 'nuevaAreas',
          component: () =>
            import('@/views/area/nuevaArea.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/home' },
                { title: 'Áreas', 'url':'/areas'},                
                { title: 'Nueva', active: true },
              ],            
          }
        },
        {
          path: '/areas/editar/:id',
          name: 'editarAreas',
          component: () =>
            import('@/views/area/nuevaArea.vue'),
            meta: {
              breadcrumb: [
                  { title: 'Home', url: '/home' },
                  { title: 'Áreas', 'url':'/areas'}, 
                  { title: 'Editar', active: true },
              ],            
          }
        },
        {
          path: '/asignaturas',
          name: 'Asignatura',
          component: () =>
            import('@/views/asignatura/asignaturas.vue')
        },
        {
          path: '/prueba',
          name: 'prueba',
          component: () =>
            import('@/views/prueba.vue')
        },
        {
          path: '/imagen',
          name: 'cargar-imagen',
          component: () =>
            import('@/views/components/imagen/lista.vue')
        },
        {
          path: '/asignaturas/nueva',
          name: 'nuevaAsignatura',
          component: () =>
            import('@/views/asignatura/nuevaAsignatura.vue')
        },
        {
          path: '/asignaturas/editar/:id',
          name: 'editarAsignatura',
          component: () =>
            import('@/views/asignatura/nuevaAsignatura.vue')
        },
      
        {
          path: '/instituciones',
          name: 'Instituciones',
          component: () =>
            import('@/views/institucion/screen.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/home' },
                { title: 'Instituciones', active: true },
              ],            
          }
        },
        {
          path: '/institucion/detalle',
          name: 'Instituciones',
          component: () =>
            import('@/views/institucion/menu.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/home' },
                { title: 'Instituciones', url: '/instituciones' },
                { title: 'Detalle', active: true },
              ],            
          }
        },
        {
          path: '/institucion/nueva',
          name: 'nuevaInstituciones',
          component: () =>
            import('@/views/institucion/nueva.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/home' },
                { title: 'Instituciones', url: '/instituciones' },
                { title: 'Nueva', active: true },
              ],            
          }
        },
        {
          path: '/institucion/editar/:id',
          name: 'editarInstituciones',
          component: () =>
            import('@/views/institucion/nueva.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/home' },
                { title: 'Instituciones', url: '/instituciones' },
                { title: 'Editar', active: true },
              ],            
          }
        },
        {
          path: '/grupos',
          name: 'grupos',
          component: () =>
            import('@/views/grupo/lista.vue')
        },
        {
          path: '/grupos/nuevo',
          name: 'nuevaGrupos',
          component: () =>
            import('@/views/grupo/nuevo.vue')
        },
        {
          path: '/grupos/editar/:id',
          name: 'editarGrupos',
          component: () =>
            import('@/views/grupo/nuevo.vue')
        },
        {
          path: '/virtual/:url',
          name: 'virutal',
          component: () =>
            import('@/views/virtual.vue')
        },
     
        {
          path: '/menu',
          name: 'adminMenu',
          component: () =>
            import('@/views/menu/listaMenu.vue')
        },
        {
          path: '/periodos',
          name: 'adminPeriodos',
          component: () =>
            import('@/views/periodos/listaPeriodos.vue')
        },
        {
          path: '/periodosInstitucion',
          name: 'adminPeriodosInstitucion',
          component: () =>
            import('@/views/periodos/periodosInstitucion.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/home' },
                { title: 'Instituciones', url: '/instituciones' },
                { title: 'Periodos', active: true },
              ],            
          }
        },
        {
          path: '/usuarios',
          name: 'adminUsuarios',
          component: () =>
            import('@/views/usuarios/usuarios.vue'),
            meta: {
              breadcrumb: [
                  { title: 'Panel', url: '/home' },
                  { title: 'Usuarios', active: true }
              ],
          }
        },
        {
          path: '/usuario/nuevo',
          name: 'nuevaDocente',
          component: () =>
            import('@/views/usuarios/components/nuevo.vue'),
            meta: {
              breadcrumb: [
                  { title: 'Panel', url: '/home' },
                  { title: 'Listado usuarios', url: '/usuarios' },
                  { title: 'Nuevo', active: true }
              ],
          }
        },
        {
          path: '/usuario/editar/:id',
          name: 'editarUsuario',
          component: () =>
            import('@/views/usuarios/components/nuevo.vue'),
            meta: {
              breadcrumb: [
                  { title: 'Panel', url: '/home' },
                  { title: 'Listado usuarios', url: '/usuarios' },
                  { title: 'Editar', active: true }
              ],
          }
        },
        //=====RUTAS LIBROS====================
        {
          path: "/admin/contenidos",
          name: "admin-contenidos",
          component: () => import("./views/unidades/listaUnidades.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/home" },
              { title: "Gestion libros", active: true }
            ],
          }
        },
        {
          path: "/docente/libros2",
          name: "libros2",
          component: () => import("./views/docentes/libros2.vue")
        },
        {
          path: "/docente/libro/detallelibro",
          name: "desgloselibro",
          component: () => import("./views/libros/desgloselibro.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/home" },
              { title: "Mis libros", url: "/docente/libros2" },
              { title: "Contenido libro", active: true }
            ],
          }
        },
        //=====FIN RUTAS LIBROS================
        //================RUTA PARA CURSOS==============================
        {
          path: "/docente/curso/nuevo",
          name: "cursos",
          component: () => import("./views/docentes/nuevo.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/home" },
              { title: "Mis libros", url: "/docente/libros2" },
              { title: "Contenido libro", url: "/docente/libro/desgloselibro" },
              { title: "Agregar curso", active: true }
            ],
          }
        },
        //estudiante
        {
          path: "/estudiante/cursos",
          name: "cursosestudiantes",
          component: () => import("./views/estudiantes/cursos.vue")
        },
        {
          path: "/estudiante/evaluaciones",
          name: "estudiante-evaluaciones",
          component: () => import("./views/estudiantes/ScreenEvaluaciones.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/home" },
              { title: "Mis cursos", url: "/estudiante/cursos" },
              { title: "Contenido curso", active: true }
            ],
          }
        },
        {
          path: "/estudiante/mostrar-evaluaciones",
          name: "mostrar-evaluaciones",
          component: () => import("./views/estudiantes/evaluaciones/EstudianteScreenEvaluacion.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/home" },
              { title: "Mis cursos", url: "/estudiante/cursos" },
              { title: "Mis evaluaciones", url: "/estudiante/evaluaciones" },
              { title: "Revisión evaluación", active: true }
            ],
          }
        },
        {
          path: "/estudiante/repaso-evaluaciones",
          name: "repaso-evaluaciones",
          component: () => import("./views/estudiantes/repasoEvaluaciones/repaso.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/home" },             
              { title: "Repaso evaluación", active: true }
            ],
          }
        },
        //docente
        {
          path: "/docente/desglose_curso",
          name: "desglose_curso",
          component: () => import("./views/docentes/desglose_curso.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/home" },
              { title: "Mis libros", url: "/docente/libros2" },
              { title: "Contenido libro", url: "/docente/libro/desgloselibro" },
              { title: "Contenido curso", active: true }
            ],
          }
        },
        {
          path: "/docente/curso/editar",
          name: "cursos",
          component: () => import("./views/docentes/nuevo.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/home" },
              { title: "Mis libros", url: "/docente/libros2" },
              { title: "Contenido libro", url: "/docente/libro/desgloselibro" },
              { title: "Editar curso", active: true }
            ],
          }
        },
        //================FIN RUTA PARA CURSOS==========================
        //================RUTA PARA LIBROS===========================================
        //estudiante
        {
          path: "/estudiante/libros",
          name: "librosestudiantes",
          component: () => import("./views/estudiantes/libros.vue")
        },
      
        //================FIN RUTA PARA LIBROS=======================================
          //======================RUTA PARA COMUNICADOS==============================
          {
            path: "/comunicaciones",
            name: "comunicaciones",
            component: () => import("@/views/comunicados/MenuComunicados.vue"),
            meta: {
              breadcrumb: [
                { title: "Home", url: "/home" },
                { title: "Comunicaciones", active: true }
              ]
            }
          },
          {
            path: "/Comunicaciones/docentes",
            name: "comunicaciones-docentes",
            component: () => import("@/views/comunicados/MenuComunicados.vue"),
            meta: {
              breadcrumb: [
                { title: "Home", url: "/home" },
                { title: "Contenido del libro", url: "/docente/libro/desgloselibro" },
                { title: "Desglose del curso", url: "/docente/desglose_curso" },
                { title: "Comunicaciones", active: true }
              ]
            }
          },
          {
            path: "/Comunicaciones/estudiantes",
            name: "comunicaciones-estudiantes",
            component: () => import("@/views/comunicados/MenuComunicados.vue"),
          },
          {
            path: "/comunicacion/docente",
            name: "comunicacion-docente",
            component: () => import("@/views/comunicados/MenuComunicados.vue"),
            meta: {
              breadcrumb: [
                { title: "Home", url: "/home" },
                { title: "Comunicaciones", active: true }
              ]
            }
          },
          {
            path: "/Comunicaciones/directores",
            name: "comunicaciones-directores",
            component: () => import("@/views/comunicados/MenuComunicados.vue"),
            meta: {
              breadcrumb: [
                { title: "Home", url: "/home" },
                // { title: "Listado de cursos", url: "/estudiante/cursos" },
                { title: "Comunicaciones", active: true }
              ]
            }
          },
          //======================FIN RUTA PARA COMUNICADOS==========================
          //======================RUTAS PARA RECURSOS================================
          {
            path: "/mostrar/recurso",
            name: "recurso-mostrar",
            component: () => import("@/views/recursos/ListadoRecursos.vue"),
            meta: {
              breadcrumb: [
                { title: "Home", url: "/home" },
                { title: "Desglose libro", url: "/docente/libro/desgloselibro" },
                { title: "Listado recursos", active: true }
              ]
            }
          },
          //======================FIN RUTAS PARA RECURSO=============================
          //======================RUTAS PARA CODIGOS================================
          {
            path: "/admin/generarcodigos",
            name: "admin-generarcodigos",
            component: () => import("./views/codigos/CodigosLibrosComponent2.vue"),
            meta: {
              breadcrumb: [
                { title: "Home", url: "/home" },
                { title: "Códigos", active: true }
              ],              
            }
          },
          //========================FIN RUTAS PARA CODIGOS=============================
        {
          path: '/salir',
          name: 'salir',
          component: () =>
            import('@/views/pages/logout.vue')
        },
        {
          path: '/docente/editar/:id',
          name: 'editarDocente',
          component: () =>
            import('@/views/usuarios/components/nuevo.vue'),
            meta: {
              breadcrumb: [
                  { title: 'Panel', url: '/home' },
                  { title: 'Instituciones', url: '/instituciones' },
                  { title: 'Detalle', url: '/institucion/detalle' },
                  { title: 'Editar usuario', active: true }
              ],
          }
        },
        {
          path: '/estudiante/editar/:id',
          name: 'editarestudiante',
          component: () =>
            import('@/views/usuarios/components/nuevo.vue'),
            meta: {
              breadcrumb: [
                  { title: 'Panel', url: '/home' },
                  { title: 'Instituciones', url: '/instituciones' },
                  { title: 'Detalle', url: '/institucion/detalle' },
                  { title: 'Editar usuario', active: true }
              ],
          }
        },
        //RUTAS PARA USUARIOS
        //director
        {
          path: "/director/instituciones",
          name: "directorInstituciones",
          component: () => import("./views/director/institucionesDirector.vue"),
          meta: {
            breadcrumb: [
              { title: "Inicio", url: "/" },
              { title: "Lista instituciones", active: true }
            ],
          }
        },
        //FIN RUTAS PARA USUARIOS
        //EVALUACIONES
        {
          path: "/admin/desafios",
          name: "evaluaciones-administrador",
          component: () => import("./views/evaluaciones/screen.vue"),
          meta: {
            breadcrumb: [
              { title: "Inicio", url: "/" },
              { title: "Desafíos AZ", active: true }
            ],
          }
        },
        //FIN RUTAS EVALUACIONES
        {
          path: "/config",
          name: "menu-config",
          component: () => import("./views/config/screenconfig.vue"),
          meta: {
            breadcrumb: [
              { title: "Inicio", url: "/" },
              { title: "Configuraciones", active: true }
            ]
          }
        },
        //juegos
        {
          path: "/games",
          name: "admin-games",
          component: () => import("./views/games/screen.vue"),
          meta: {
            breadcrumb: [
              { title: "Inicio", url: "/" },
              { title: "Games", active: true }
            ]
          }
        },
        //fin juegos
        //EVALUACIONES DOCENTES
        {
          path: "/docente/evaluaciones",
          name: "docente-evaluaciones",
          component: () => import("./views/docentes/screen_evaluaciones.vue"),
          meta: {
            breadcrumb: [
              { title: "Inicio", url: "/" },
              { title: "Desafíos AZ", active: true }
            ]
          }
        },
        //fin EVALUACIONES DOCENTES
        //plataformas
        {
          path: "/docente/plataformas",
          name: "docente-plataformas",
          component: () => import("./views/plataformas/lista.vue"),
          meta: {
            breadcrumb: [
              { title: "Inicio", url: "/" },
              { title: "Plataformas", active: true }
            ]
          }
        },
        //fin plataformas
        //plataformas
        {
          path: "/estudiante/plataformas",
          name: "estudiante-plataformas",
          component: () => import("./views/plataformas/lista.vue"),
          meta: {
            breadcrumb: [
              { title: "Inicio", url: "/" },
              { title: "Plataformas", active: true }
            ]
          }
        },
        //fin plataformas
      ],
    },
    
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
